module.exports = __webpack_public_path__ + "img/horizontal-bar-chart-01.c9baa071.svg";